/**
 * API Configuration Constants
 */

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_URL || '',
  WITH_CREDENTIALS: true,
  HEADERS: {
    'Content-Type': 'application/json'
  }
} as const;

/**
 * API Endpoint Paths
 * Note: BASE_URL already includes /api, so endpoints should NOT have /api prefix
 */
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    ME: '/auth/me'
  },
  N8N: {
    WORKFLOWS: '/n8n/workflows',
    EXECUTIONS: '/n8n/executions',
    EXECUTE_WORKFLOW: (id: string | number) => `/n8n/workflows/${id}/execute`,
    SET_WORKFLOW_ACTIVE: (id: string | number) => `/n8n/workflows/${id}/active`
  },
  ADMIN: {
    WORKFLOW_TAGS: '/admin/workflow-tags',
    WORKFLOW_TAG: (tagName: string) => `/admin/workflow-tags/${tagName}`,
    WORKFLOW_TAG_METRICS: '/admin/workflow-tags/metrics'
  },
  ANALYTICS: '/analytics',
  WORKFLOW_REGISTRY: {
    LIST: '/workflow-registry',
    GET: (id: string) => `/workflow-registry/${id}`,
    EXECUTE: (id: string) => `/workflow-registry/${id}/execute`
  }
} as const;
